<template>
  <div id="app">
    <div v-if="!loading && landing">
      <router-view/>
    </div>
    <div id="app-wrapper" class="wrapper" v-if="user && user._id && !landing">
      <Header></Header>
      <Sidebar></Sidebar>
      <div class="main-panel">
        <router-view/>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'

import Auth from './services/auth'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import Footer from './components/Footer'

export default {
  name: 'App',
  data: function () {
    return {
      loading: true,
      user: null,
      defaultImage: 'https://indiefy.net/img/img-placeholder.jpg',
      credits: 0,
      landing: false,
      publicRoutes: [
        '/',
        '/landing',
        '/login'
      ]
    }
  },
  methods: {
    checkLogin: function () {
      Auth.getUser().then(response => {
        _.extend(this.$user, response.data)

        this.loading = false
        this.user = response.data
        localStorage.setItem('user', JSON.stringify(this.user))

        if (_.includes(this.publicRoutes, this.$route.path)) {
          this.landing = true
        }

        this.$forceUpdate()
      }).catch(() => {
        localStorage.removeItem('user')
        this.$user = {}
        this.loading = false
        this.landing = true
        this.$router.push('/landing')
      })
    }
  },
  created: function () {
    this.checkLogin()
    this.$eventBus.$on('loggedIn', () => this.checkLogin())
    this.$eventBus.$on('refreshUser', () => this.checkLogin())
  },
  watch: {
    '$route' (to, from) {
      if (_.contains(this.publicRoutes, this.$route.path)) {
        this.landing = true
      } else {
        this.landing = false
      }
    }
  },
  components: {
    Header,
    Sidebar,
    Footer
  }
}
</script>

<style lang="scss">
@import "assets/sass/atlantis";
@import "assets/sass/wizard";
@import "assets/sass/select2";
@import "assets/sass/datepicker";
@import "assets/sass/tags";
@import "assets/sass/player";
@import "assets/sass/rating";
@import "assets/sass/invoice";
@import "assets/sass/messages";
@import "assets/sass/vectormap";
@import "assets/sass/custom";

body {
  margin: 0;
}

@media screen and (max-width:576px) {
  .form-group {
    label {
      text-align: left !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue